<template>
    <canvas v-show="preloadFound" ref="canvas"></canvas>
    <img v-if="!preloadFound" :src="src"/>
</template>

<script>
import { getPreloadedImage } from '@/helpers/assetHelper';

export default {
  name: 'PreloadedImage',
  components: {},
  props: {
      src: String
  },
  data()
  {
    return {
      preloadFound: false
    }
  },
  mounted()
  {
    var imageElement = getPreloadedImage(this.src);

    if (imageElement)
    {
      this.preloadFound = true;
      this.$refs.canvas.width = imageElement.width;
      this.$refs.canvas.height = imageElement.height;
      this.ctx = this.$refs.canvas.getContext('2d');

      this.ctx.drawImage(imageElement, 0, 0);
    }

  }
}
</script>
